import { createSelector } from 'reselect'
import * as storesSelectors from 'services/Stores/selectors'
import * as stateSelectors from 'services/States/selectors'
import * as cmsSelectors from 'services/cms/selector'
import * as featureFlagsSelector from 'services/FeatureFlags/selectors'
import {
  getRequestError,
  requestIsGetStateSelector,
  requestIsSearchingSelector,
} from 'services/Request/selectors'
import { SEARCH_REQUESTED } from 'services/Stores/actionTypes'
import { isUnavailableError } from './errorUtils'

export const selector = createSelector(
  [
    getRequestError(SEARCH_REQUESTED),
    storesSelectors.storeList,
    storesSelectors.totalCount,
    storesSelectors.searchTerm,
    requestIsSearchingSelector,
    storesSelectors.filterGroups,
    storesSelectors.selectedStore,
    storesSelectors.selectedMarker,
    storesSelectors.isSearchingByMapArea,
    stateSelectors.states,
    requestIsGetStateSelector,
    cmsSelectors.cms,
    featureFlagsSelector.featureFlags,
  ],
  (
    error,
    storeList,
    totalCount,
    searchTerm,
    isSearching,
    filters,
    selectedStore,
    selectedMarker,
    isSearchingByMapArea,
    states,
    isFetchingStates,
    cmsData,
    { loaded, values },
  ) => ({
    hasUnavailableError: error && isUnavailableError(error),
    storeList,
    totalCount,
    searchTerm,
    isSearching,
    filters,
    selectedStore,
    isSearchingByMapArea,
    selectedMarker,
    states,
    isFetchingStates,
    cmsData,
    featureFlags: values,
    isFeatureFlagLoaded: loaded,
  }),
)
